import { memo, useMemo } from 'react'
import TimeRangeSelector from '../TimeRangeSelector'
import { formatDateForInput } from '../../../utils/dateUtils'

const ChartControls = memo(({
  timeRange,
  onTimeRangeChange,
  isExternallySetCustom,
  onExternalCustomProcessed,
}) => {
  const initialStartTime = useMemo(() =>
    timeRange.startTime ? formatDateForInput(new Date(timeRange.startTime)) : '',
    [timeRange.startTime],
  )
  const initialEndTime = useMemo(() =>
    timeRange.endTime ? formatDateForInput(new Date(timeRange.endTime)) : '',
    [timeRange.endTime],
  )

  return (
    <div className="mb-4">
      <TimeRangeSelector
        value={timeRange.duration}
        onChange={onTimeRangeChange}
        includeExtendedRanges
        initialStartTime={initialStartTime}
        initialEndTime={initialEndTime}
        isExternallySetCustom={isExternallySetCustom}
        onExternalCustomProcessed={onExternalCustomProcessed}
      />
    </div>
  )
})

ChartControls.displayName = 'ChartControls'

export default ChartControls